export const setStyleForSvgElement: (className: string, width: string, heightSvg: number) => void = (className, width, heightSvg) => {
    const element = document.getElementById(className) as HTMLElement;
    element.style.width = width;
    element.style.height = `${heightSvg}px`;
};

export const setMarginSeat = (elements: HTMLElement[], verticalDistance: number, angle: number, seatStart: number) => {
    var i = 0;
    for (let element of elements) {
        if (Number(element.id) >= seatStart) {
            const angleDegree = (180 * angle) / Math.PI;
            i += 1;
            const margin = i * verticalDistance * Math.tan(angle);
            if (element.children[0].children.length > 1) {
                element.style.margin = `0 ${margin}px`;
                if (element.children[0].children[0] as HTMLElement) {
                    const child1 = element.children[0].children[0] as HTMLElement;
                    child1.style.transform = `rotate(-${angleDegree - 1}deg)`;
                }
                if (element.children[0].children[2] as HTMLElement) {
                    const child2 = element.children[0].children[2] as HTMLElement;
                    child2.style.transform = `rotate(${angleDegree - 1}deg)`;
                }
                if (element.children[0].children[4] as HTMLElement) {
                    const child2 = element.children[0].children[4] as HTMLElement;
                    child2.style.transform = `rotate(${angleDegree - 1}deg)`;
                    const child1 = element.children[0].children[2] as HTMLElement;
                    child1.style.transform = ``;
                }
            } else {
                element.style.margin = `0 ${margin + 10}px`;
            }
        } else {
            element.style.margin = "E";
        }
    }
};

export const convertNodeListToElement = (nodes: HTMLCollectionOf<Element>) => {
    let array = [];
    for (let i = 0, le = nodes.length; i < le; i++) {
        array.push(nodes[i] as HTMLElement);
    }
    return array;
};

export const setTailStyle = (width: number, inputHeight: number) => {
    const parentElement = document.querySelector(".seat-map-tail") as HTMLElement;
    const element = parentElement.firstElementChild as HTMLElement;
    const elementBody = document.querySelector(".seat-map-body") as HTMLElement;
    element.style.width = `${width}px`;
    elementBody.style.height = `${inputHeight}px`;
};

export const computeNoseData = (
    verticalDimension: number,
    width: number,
    pointEndRow: number,
    bizierPoint: number[],
    inputPoint: number[][]
) => {
    const point1 = [width / 2, 0];
    const point2 = [0, pointEndRow * verticalDimension];
    const distancePoints = [
        Math.abs(point2[0] - point1[0]),
        Math.abs(point2[1] - point1[1]),
    ];
    const distanceInputPointsOfx = Math.abs(inputPoint[0][0] - inputPoint[1][0]);
    const distanceInputPointsOfy = Math.abs(inputPoint[0][1] - inputPoint[1][1]);
    const bizierDx = Math.abs(inputPoint[0][0] - bizierPoint[0]);
    const bizierDy = Math.abs(inputPoint[0][1] - bizierPoint[1]);
    const bizierRelativeOfx = bizierDx / distanceInputPointsOfx;
    const bizierRelativeOfy = bizierDy / distanceInputPointsOfy;
    const realBizier = [
        point1[0] - bizierRelativeOfx * distancePoints[0],
        bizierRelativeOfy * distancePoints[1]
    ];
    const date = [point1, point2, realBizier];
    const revertData = date.map(item => revertingPointAsX(item, width))
    return { data: date, revert: revertData };
};

export const setNoseStyle = (elements: HTMLElement[], verticalDistance: number, angle: number, seatEnd: number[], topMargin: number) => {
    const radian = angle * Math.PI / 180
    const businessElement = document.querySelector('.business-seat') as HTMLElement;
    if (businessElement) {
        businessElement.style.visibility = "hidden";
        businessElement.style.height = `${topMargin}%`
    }
    const noseElement = document.querySelector('.seat-map-nose') as HTMLElement;
    if (noseElement)
        noseElement.style.display = "none";
    var i = seatEnd[0];
    for (let element of elements) {
        if (Number(element.id) <= seatEnd[0]) {
            i -= 1;
            const margin = i * (verticalDistance) * Math.tan(radian);
            element.style.margin = `0 ${margin}px`
        }
    }
}

export const revertingPointAsX: (point: number[], width: number) => number[] = (point, width) => {
    const x = width - point[0];
    const y = point[1];
    return [x, y]
}